import { render } from "./index.vue?vue&type=template&id=025951da"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/back-page/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "025951da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('025951da', __exports__)) {
    api.reload('025951da', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=025951da", () => {
    api.rerender('025951da', render)
  })

}


export default __exports__